import { render, staticRenderFns } from "./HelpBot.vue?vue&type=template&id=71ab632e&scoped=true"
import script from "./HelpBot.vue?vue&type=script&lang=ts"
export * from "./HelpBot.vue?vue&type=script&lang=ts"
import style0 from "./HelpBot.vue?vue&type=style&index=0&id=71ab632e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ab632e",
  null
  
)

export default component.exports